import Meta from '../../assets/companies/meta.svg';
import Google from '../../assets/companies/google.svg';
import Netflix from '../../assets/companies/netflix.svg';
import PnG from '../../assets/companies/pg.svg';
import Paypal from '../../assets/companies/paypal.svg';
import Payoneer from '../../assets/companies/payoneer.svg';

export const COMPANIES_WHO_TRUST = [
    {
        src: Meta,
        alt: 'Trusted by Meta',
    },
    {
        src: Google,
        alt: 'Trusted by Google',
    },
    {
        src: Netflix,
        alt: 'Trusted by Netflix',
    },
    {
        src: PnG,
        alt: 'Trusted by PnG',
    },
    {
        src: Paypal,
        alt: 'Trusted by Paypal',
    },
    {
        src: Payoneer,
        alt: 'Trusted by Payoneer',
    },
];
